"use es6";

const visualElementStore = new WeakMap();
export { visualElementStore };